import createFeatureEnumForType from './createFeatureEnumForType';
import FEATURE_TYPE from './FEATURE_TYPE';

export default createFeatureEnumForType(FEATURE_TYPE.ACCOUNT);
